export class Loader {
    constructor(companyId = null) {
        this.companyId = companyId;
        if (typeof window === 'undefined') {
            throw new Error('klaviyo is supported only in browser environments');
        }
    }
    load() {
        if (typeof this.api !== 'undefined') {
            return Promise.resolve(this.api);
        }
        if (typeof this.loader !== 'undefined') {
            return this.loader;
        }
        return this.loader = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
            if (window['_learnq']) {
                resolve(window['_learnq']);
                return;
            }
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = !0;
            script.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${this.companyId}`;
            script.onload = () => {
                resolve(window['_learnq']);
            };
            script.onerror = (error) => {
                reject(error);
            };
            document.head.appendChild(script);
        });
    }
}
//# sourceMappingURL=loader.js.map